// extracted by mini-css-extract-plugin
export default {"MainPageContainer":"MainPage_MainPageContainer__-FqDA"};